export * from './Airwallex';
export * from './ECPay';
export * from './Octo';
export * from './Spreedly';

export const LOCAL_STORAGE_PAYMENT_ID = 'payment_id';
export const LOCAL_STORAGE_PAYMENT_BOOKING_ID = 'payment_booking_id';
export const LOCAL_STORAGE_BILLING_FORM_VALUES = 'billing-form-values';

/** Query param marking a return from a hosted-page payment redirect. */
export const PAYMENT_REDIRECTED_QUERY_PARAM = 'payment_redirected';